






































































import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import LeafItem from "./LeafItem.vue";
import Levels from "./Levels.vue";
import { Utilities as utils } from "@/shared/utilities.ts";

@Component({
  components: {
    LeafItem,
    Levels,
  },
})
export default class PMPLineItem extends Vue {
  @Prop() model!: any;
  @Prop() modelKey!: string;
  @Prop() parentKey!: string;
  @Prop() lineItem!: any;
  @Prop() sites!: any;
  @Prop() resultIndex!: number;
  @Prop() indicatorIndex!: number;
  @Prop() readOnly: boolean;

  /** get the line items */
  get indicatorRows() {
    let rows = [];
    const isParent =
      this.lineItem.Children && this.lineItem.Children.length > 0;
    rows.push({
      ID: this.lineItem.ID,
      IsCustom: !this.lineItem.IsStandard,
      Frequency: this.lineItem.Frequency,
      DataType: this.lineItem.DataType,
      Description: this.lineItem.Description,
      Information: this.lineItem.Information,
      modelKey: this.lineItem.ID,
      isLeaf: !isParent,
      level: 1,
    });
    if (isParent) {
      this.getChildRows(rows, this.lineItem, this.lineItem.ID, 1);
    }
    return rows;
  }

  getChildRows(rows: any, item: any, parentKey: string, level: number) {
    item.Children.forEach((child) => {
      if (child.Type === "array") {
        rows.push({
          Type: "array",
          DataType: child.DataType,
          levels: child.Options,
          parentKey: parentKey,
          level: level + 1,
        });
      } else if (child.Type === "site") {
        const isParent = child.Children && child.Children.length > 0;
        if (this.sites && this.sites.length > 0) {
          this.sites.forEach((site: any) => {
            rows.push({
              ID: site.name,
              Description: site.name,
              modelKey: `${parentKey}.${site.name.replace(/\./g, '%2E')}`,
              isLeaf: !isParent,
              level: level + 1,
            });
            if (isParent) {
              this.getChildRows(
                rows,
                child,
                `${parentKey}.${site.name.replace(/\./g, '%2E')}`,
                level + 1
              );
            }
          });
        } else {
          // #. if no record exists, show option all
          let allSites = this.$t("All sites");
          rows.push({
            ID: "All",
            Description: allSites,
            modelKey: `${parentKey}.All`,
            isLeaf: !isParent,
            level: level + 1,
          });
          if (isParent) {
            this.getChildRows(rows, child, `${parentKey}.All`, level + 1);
          }
        }
      } else {
        const isParent = child.Children && child.Children.length > 0;
        rows.push({
          ID: child.ID,
          Description: child.Description,
          Information: child.Information,
          DataType: child.DataType,
          modelKey: `${parentKey}.${child.ID}`,
          isLeaf: !isParent,
          level: level + 1,
        });
        if (isParent) {
          this.getChildRows(rows, child, `${parentKey}.${child.ID}`, level + 1);
        }
      }
    });
  }
}
